import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Invest from "../pages/Invest";
import Faq from "../pages/others/Faq";
import Regularv1 from "../pages/others/Regular-1";
import Regularv2 from "../pages/others/Regular-2";
import Terms from "../pages/others/Terms";
import UserProfileRegular from "../pages/pre-built/user-manage/UserProfileRegular";
import UserProfileSetting from "../pages/pre-built/user-manage/UserProfileSetting";
import UserProfileNotification from "../pages/pre-built/user-manage/UserProfileNotification";
import UserProfileActivity from "../pages/pre-built/user-manage/UserProfileActivity";

import CustomerAdminLayout from "../pages/customer-admin/CustomerAdminLayout";
import SubscriptionAccess from "../pages/customer-admin/SubscriptionAccess";
import CustomerInvoices from "../pages/customer-admin/CustomerInvoices";
import CustomerPayments from "../pages/customer-admin/CustomerPayments";

import Error404Modern from "../pages/error/404-modern";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Success from "../pages/auth/Success";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";

//Procurex Pages

import ViewPurchaseRequests from "../pages/purchase-requests/ViewPurchaseRequests";
import PurchaseRequestAprrovals from "../pages/purchase-requests/PurchaseRequestApprovals";
import PurchaseRequestAnalytics from "../pages/purchase-requests/PurchaseRequestAnalytics";
import TrackPurchaseRequests from "../pages/purchase-requests/TrackPurchaseRequests";

import ViewBudgetList from "../pages/budget/ViewBudget";
import TrackBudget from "../pages/budget/TraclBudget";
import BudgetApprovals from "../pages/budget/BudgetApprovals";
import BudgetAnalytics from "../pages/budget/BudgetAnalytics";

import RFQCreation from "../pages/quotations/RFQCreations";
import RFQAnalytics from "../pages/quotations/RFQAnalytics";
import RFQApprovals from "../pages/quotations/RFQApprovals";
import RFQComparison from "../pages/quotations/RFQComparison";
import RFQConversion from "../pages/quotations/RFQConversion";
import RFQView from "../pages/quotations/RFQView";
import VersionControl from "../pages/quotations/rfq-version-control/versionControl";
import RFQTracking from "../pages/quotations/RFQTracking";
import RFQFullView from "../pages/quotations/quotationView/RFQFullView";
import PublicQuotation from "../pages/quotations/PublicQuotation";
import SetPassword from "../pages/auth/SetPassword";
import SuccessMain from "../pages/auth/SuccessMain";
import EmailError from "../pages/auth/EmailError";
import ResetPassword from "../pages/auth/ResetPassword";

import PurchaseOrderMain from "../pages/purchase-orders/PurchaseOrderMain";
import ViewPurchaseOrdersList from "../pages/purchase-orders/ViewPurchaseOrder";
import TrackPurchaseOrder from "../pages/purchase-orders/TrackPurchaseOrder";
import PurchaseOrderAnalytics from "../pages/purchase-orders/PurchaseOrderAnalytics";
import PurchaseOrderAprrovals from "../pages/purchase-orders/PurchaseOrderApprovals";
import BudgetCreation from "../pages/budget/BudgetCreations";
import PendingApprovalBudget from "../pages/budget/PendingApprovalBudget";
import BudgetAnalysisReport from "../pages/budget/BudgetAnalysisReport";
import ViewInvoiceList from "../pages/invoice/ViewAllInvoices";
import ViewInvoiceDetails from "../pages/invoice/ViewInvoiceDetails";
import InvoiceApproval from "../pages/invoice/InvoiceApproval";
import TrackInvoice from "../pages/invoice/TrackInvoice";
import InvoiceAnalytics from "../pages/invoice/InvoiceAnalytics";
import QCApprovals from "../pages/quotations/QCApprovals";
import ReadyToAward from "../pages/quotations/ReadyToAward";
import ViewDetailsEdit from "../pages/quotations/ViewDetailsEdit";
import ViewAllDispatch from "../pages/dispatch/ViewAllDispatch";
import ShowDispatchDetailsWrapper from "../pages/dispatch/showDispatchDetailsWrapper";
import ViewAllDeliveredGRN from "../pages/dispatch/ViewAllDeliveredGRN";
import InvoicePayables from "../pages/payments/invoicePayables";
import PendingPaymentApprovals from "../pages/payments/pendingPaymentApprovals";
import RunPayments from "../pages/payments/runPayments";
import ViewPayments from "../pages/payments/viewPayments";
import Main from "../pages/credit-debit-note/Main";
import ViewAllCN from "../pages/credit-debit-note/ViewAllCN";
import ViewPendingApprovalCN from "../pages/credit-debit-note/ViewPendingApprovalCN";
import NewPurchaseRequestMain from "../pages/purchase-requests/NewPRMain";
import ViewPRDetails from "../pages/purchase-requests/ViewPRDetails";
import TrackPRList from "../pages/purchase-requests/TrackPRList";
import PurchaseOrderApprovalsWrapper from "../pages/purchase-orders/PurchaseOrderApprovalsWrapper";
import PurchaseOrderViewWrapper from "../pages/purchase-orders/PurchaseOrderViewWrapper";
import { useDispatch } from "react-redux";
import { fetchCurrentUser } from "../store/slices/misc/currentUser";

import PaymentsAnalytics from "../pages/payments/PaymentsAnalytics";
import { useSelector } from "react-redux";
import { updateAccessibility } from "../store/slices/misc/accessibility";
import { updateMenuData } from "../store/slices/misc/menuData";
import { Flex, Spin } from "antd";
import { updateAllowedRoutes } from "../store/slices/misc/allowedRoutes";
import PoInvoiceDetails from "../pages/purchase-orders/OrderToInvoiceCreation";
import ViewMaterialInvoices from "../pages/invoice/ViewMaterialInvoices";
import { fetchSequenceAccess } from "../store/slices/misc/sequenceAccess";
import ViewBudgetDetails from "../pages/budget/ViewBudgetDetails";
import Cookies from "js-cookie";
import QCList from "../pages/quotations/QCList";
import MaterialIssue from "../pages/inventory/MaterialIssue";
import SiteIssue from "../pages/inventory/SiteIssue";
import InventoryPendingApproval from "../pages/inventory/PendingApprovals";
import ViewAllReportsList from "../pages/reports/view-all-reports";
import PurchaseOrderReports from "../pages/reports/purchase-reports/purchaseOrderReports";
import PurchaseOrderPreview from "../pages/reports/purchase-reports/purchaseOrderPreview";
import PurchaseBySupplier from "../pages/reports/purchase-reports/purchaseBySupplier";
import PurchaseBySupplierDetailReport from "../pages/reports/purchase-reports/purchaseBySupplierDetailReport";
import PurchaseByMaterialReport from "../pages/reports/purchase-reports/purchaseByMaterialReport";
import PurchaseByMaterialDetailReport from "../pages/reports/purchase-reports/purchaseByMaterialDetailReport";
import PurchaseByCategoryReport from "../pages/reports/purchase-reports/purchaseByCategoryReport";
import OrderDetailsByCategoryReport from "../pages/reports/purchase-reports/orderDetailsByCategoryReport";
import PurchaseBySiteReport from "../pages/reports/purchase-reports/purchaseBySiteReport";
import OrderDetailsBySiteReport from "../pages/reports/purchase-reports/orderDetailsBySiteReport";
import InvoiceBySupplierReport from "../pages/reports/purchase-reports/invoiceBySupplierReport";
import InvoicePreviewReport from "../pages/reports/purchase-reports/invoicePreviewReport";
import DeliveryNoteDetailsReport from "../pages/reports/purchase-reports/deliveryNoteDetailsReport";
import MaterialsByDeliveryNoteReport from "../pages/reports/purchase-reports/materialsByDeliveryNoteReport";
import SupplierPaymentsReport from "../pages/reports/accounts-payable-reports/supplierPaymentsReport";
import SupplierPaymentsInvoiceReport from "../pages/reports/accounts-payable-reports/supplierPaymentsInvoiceReport";
import PaymentsAgingSummaryReport from "../pages/reports/accounts-payable-reports/paymentsAgingSummaryReport";
import ApprovedMaterialReport from "../pages/reports/inventory-reports/approvedMaterialReport";
import MaterialsToSiteReport from "../pages/reports/inventory-reports/materialsToSiteReport";
import ReturnsFromSiteReport from "../pages/reports/inventory-reports/returnsFromSiteReport";
import InventorySummaryReport from "../pages/reports/inventory-reports/inventorySummaryReport";
import CommittedStockReport from "../pages/reports/inventory-reports/committedStockReport";
import InventoryValueReport from "../pages/reports/inventory-reports/inventoryValueReport";
import InventoryTrackReport from "../pages/reports/inventory-reports/inventoryTrackReport";
import InventoryAgingReport from "../pages/reports/inventory-reports/inventoryAgingReport";
import MaterialUtilizationReport from "../pages/reports/inventory-reports/materialUtilizationReport";
import StockSummaryReport from "../pages/reports/inventory-reports/stockSummaryReport";
import ABCClassification from "../pages/reports/inventory-reports/abcClassification";
import MaterialFlowByContractorReport from "../pages/reports/inventory-reports/materialFlowByContractorReport";
import MaterialBalanceBreakdown from "../pages/reports/inventory-reports/materialBalanceBreakdown";
import PaymentsAgingReport from "../pages/reports/accounts-payable-reports/paymentsAgingReport";
import PaymentsReport from "../pages/reports/accounts-payable-reports/paymentsReport";
import InvoiceDetailsForPaymentsReport from "../pages/reports/accounts-payable-reports/invoiceDetailsForPaymentsReport";
import InventoryValueReportPreview from "../pages/reports/inventory-reports/inventoryValueReportPreview";
import StockAvailabilityReport from "../pages/inventory/StockAvailabilityReport";
import MaterialDetails from "../pages/inventory/MaterialDetails";
import SupplierBalancesReport from "../pages/reports/accounts-payable-reports/supplierBalancesReport";
import SupplierBalancesDetailReport from "../pages/reports/accounts-payable-reports/supplierBalancesDetailReport";
import SupplierLedgerReport from "../pages/reports/accounts-payable-reports/supplierLedgerReport";
import GRNPreview from "../pages/reports/purchase-reports/grnPreview";
import PaymentsAgingSummaryInvoiceReport from "../pages/reports/accounts-payable-reports/paymentsAgingSummaryInvoiceReport";
import BOQCreationMain from "../pages/boq/boqCreationMain";
import BOQList from "../pages/boq/boqList";
import BoqReport from "../pages/boq/boqReport";
import BoqViewDeatils from "../pages/boq/boqViewDetails";
import InventoryAnalytics from "../pages/inventory/InventoryAnalytics";
import ViewPendingApprovalsGRN from "../pages/dispatch/ViewPendingApprovalsGRN";
import ViewAllReturns from "../pages/returns/ViewAllReturns";
import ViewPendingApprovalsReturns from "../pages/returns/ViewPendingApprovalsReturns";
import ViewReturnDetails from "../pages/returns/ViewReturnDetails";
import ExcelExportRequestedList from "../pages/pre-built/user-manage/ExcelExportRequestedList";
import NotificationMain from "../pages/notifications/NotificationMain";
import BudgetTrackReport from "../pages/reports/budget-reports/budgetTrackReport";
import MaterialConsumptionReport from "../pages/reports/budget-reports/materialConsumptionReport";
import MaterialRequestSummaryList from "../pages/reports/material-management-reports/materialRequestSummaryList";
import MaterialIssueSummary from "../pages/reports/material-management-reports/materialIssueSummary";
import MaterialUtilizedSummary from "../pages/reports/material-management-reports/materialUtilizedSummary";
import MaterialDamageSummary from "../pages/reports/material-management-reports/materialDamageSummary";
import MaterialSummary from "../pages/reports/material-management-reports/materialSummary";
import MaterialSummaryDetailReport from "../pages/reports/MaterialSummaryDetailReport";
import MaterialConsumptionDetailReport from "../pages/reports/MaterialConsumptionDetailReport";
import ViewBoqDetails from "../pages/boq/boqViewDetails";
import VersionControlDefaultTemplate from "../pages/version-control/versionControlDefaultTemplate";
import POVersionControl from "../pages/purchase-orders/POVersionControl";
import PRVersionControl from "../pages/purchase-requests/PRVersionControl";
import BulkUploadList from "../pages/pre-built/user-manage/ExcelUploadRequestedList";
import DefaultDashboardPage from "../pages/DefaultDashboard";
import { HomeOutlined } from "@ant-design/icons";
import RateContractMain from "../pages/rate-contract/RateContractMain";
import PRSummaryDetailsPage from "../pages/dashboard/PRSummaryDetailsPage";
import RateContractAprrovals from "../pages/rate-contract/RateContractApprovals";
import ViewRateContractsList from "../pages/rate-contract/ViewRateContract";
import RateContractViewWrapper from "../pages/rate-contract/RateContractViewWrapper";
import RateContractApprovalsWrapper from "../pages/rate-contract/RateContractApprovalsWrapper";
import MaterialHandoverList from "../pages/inventory/MaterialHandoverList";
import PendingHandover from "../pages/inventory/PendingHandover";
import MaterialHandoverPendingDetails from "../pages/inventory/MaterialHandoverPendingDetails";
import MaterialHandoverListDetails from "../pages/inventory/MaterialHandoverListDetails";
import MaterialUtilizationList from "../pages/inventory/MaterialUtilizationList";
import MaterialUtilizationListDetails from "../pages/inventory/MaterialUtilizationListDetails";
import ShowGRNPendingDetailsWrapper from "../pages/dispatch/ShowGRNPendingDetailsWrapper";
import Suppliers from "../pages/masters/supplier/Suppliers";
import AddSupplier from "../pages/masters/supplier/AddSupplier";

const globalRoutes = [
  "/",
  "/auth-reset",
  "/auth-success",
  "/auth-register",
  "/setPassword",
  "/success",
  "/errorEmail",
  "/privacy",
  "/public-links/rfq/:linkId",
  // "/notifications",
];
const routesMap = {
  dashboard: <Invest />,
  "pr-summary-details": <PRSummaryDetailsPage />,
  // notifications: <NotificationMain />,
  "add-new-purchase-request": <NewPurchaseRequestMain />,
  "approvals-purchase-request": <PurchaseRequestAprrovals />,
  "view-purchase-requests": <ViewPurchaseRequests />,
  "track-purchase-requests/:prId": <TrackPurchaseRequests />,
  "analytics-purchase-requests": <PurchaseRequestAnalytics />,
  "view_pr/:prId": <ViewPRDetails />,
  prHistory: <PRVersionControl />,
  "track-list": <TrackPRList />,
  "new-budget": <BudgetCreation />,
  "budget-approvals": <BudgetApprovals />,
  "view-budget": <ViewBudgetList />,
  "pendingApproval-budget": <PendingApprovalBudget />,
  "track-budget": <TrackBudget />,
  "analytics-budget": <BudgetAnalytics />,
  "view_budget_details/:budgetId": <ViewBudgetDetails />,
  "budget-analysis/:budgetId": <BudgetAnalysisReport />,
  "new-rfq": <RFQCreation />,
  "qc-list": <QCList />,
  "rfq-approvals": <RFQApprovals />,
  "qc-approvals": <QCApprovals />,
  "view-rfqs": <RFQView />,
  viewhistory: <VersionControl />,
  // viewhistory: <VersionControlDefaultTemplate />,
  "track-rfqs": <RFQTracking />,
  "analytics-rfq": <RFQAnalytics />,
  "rfq-comparison": <RFQComparison />,
  "rfq-conversion": <RFQConversion />,
  "rfq-full-view": <RFQFullView />,
  "ready-to-award": <ReadyToAward />,
  "view/:qid": <ViewDetailsEdit />,
  "public-links/rfq/:linkId": <PublicQuotation />,
  "purchase-order-new": <PurchaseOrderMain />,
  "approvals-purchase-order": <PurchaseOrderAprrovals />,
  "approvals-purchase-order/:orderNumber": <PurchaseOrderApprovalsWrapper />,
  "view-purchase-order": <ViewPurchaseOrdersList />,
  "view-purchase-order/:orderNumber": <PurchaseOrderViewWrapper />,
  "poHistory/:orderNumber": <POVersionControl />,
  "track-purchase-order": <TrackPurchaseOrder />,
  "analytics-purchase-order": <PurchaseOrderAnalytics />,
  "rate-contract-new": <RateContractMain />,
  "approvals-rate-contract": <RateContractAprrovals />,
  "approvals-rate-contract/:orderNumber": <RateContractApprovalsWrapper />,
  "view-rate-contract": <ViewRateContractsList />,
  "view-rate-contract/:orderNumber": <RateContractViewWrapper />,
  "credit-debit-note-new": <Main />,
  "all-credit-debit-notes": <ViewAllCN />,
  "pending-approval-credit-debit-notes": <ViewPendingApprovalCN />,
  "invoice-payables": <InvoicePayables />,
  "add-purchase-invoice/:orderNumber": <PoInvoiceDetails />,
  "pending-payment-approvals": <PendingPaymentApprovals />,
  "run-payments": <RunPayments />,
  "view-payments": <ViewPayments />,
  "payment-analytics": <PaymentsAnalytics />,
  "view-material-invoices/:orderNumber/:lineNo": <ViewMaterialInvoices />,
  "view-invoice-list": <ViewInvoiceList />,
  "view-invoice/:id": <ViewInvoiceDetails />,
  "approvals-purchase-invoice": <InvoiceApproval />,
  "track-purchase-invoice": <TrackInvoice />,
  "analytics-purchase-invoice": <InvoiceAnalytics />,
  "view-dispatch-list": <ViewAllDispatch />,
  "delivered-dispatch-list": <ViewAllDeliveredGRN />,
  "pending-approvals-grn-list": <ViewPendingApprovalsGRN />,
  "view-dispatch-details/:id": <ShowDispatchDetailsWrapper />,
  "view-grn-pending-approval/:id":<ShowGRNPendingDetailsWrapper />,
  "view-returns": <ViewAllReturns />,
  "pending-approvals-returns": <ViewPendingApprovalsReturns />,
  "view-return-details/:returnNumber": <ViewReturnDetails />,
  "payments-analytics": <PaymentsAnalytics />,
  "terms-policy": <Terms />,
  faq: <Faq />,
  privacy: <Faq />,
  "pages/regular-v1": <Regularv1 />,
  "pages/regular-v2": <Regularv2 />,
  "material-issue": <MaterialIssue />,
  "site-inventory": <SiteIssue />,
  "material-handover-pending-details/:id": <MaterialHandoverPendingDetails />,
  "material-handover-details/:id": <MaterialHandoverListDetails />,
  "material-handover-list": <MaterialHandoverList />,
  "material-handover-pending": <PendingHandover />,
  "material-utilization": <MaterialUtilizationList />,
  "material-utilization-details/:id": <MaterialUtilizationListDetails />,
  "materialIssue-pending-approvals": <InventoryPendingApproval />,
  "dashboard-inventory": <InventoryAnalytics />,

  "view-inventory-reports": <ViewAllReportsList />,
  "inventory-approved-material-reports-list": <ApprovedMaterialReport />,
  "inventory-materials-to-site-reports-list": <MaterialsToSiteReport />,
  "inventory-returns-from-site-reports-list": <ReturnsFromSiteReport />,
  "inventory-summary-reports-list": <InventorySummaryReport />,
  "inventory-committed-stock-report-list/:id/:historyId": (
    <CommittedStockReport />
  ),
  "inventory-value-report-list": <InventoryValueReport />,
  "inventory-track-report-list": <InventoryTrackReport />,
  "inventory-aging-report-list": <InventoryAgingReport />,
  "inventory-material-utilization-report-list": <MaterialUtilizationReport />,
  "inventory-stock-summary-report-list": <StockSummaryReport />,
  "inventory-abc-classification-report-list": <ABCClassification />,
  "inventory-material-flow-by-contractor-reports-list": (
    <MaterialFlowByContractorReport />
  ),
  "material-balance-breakdown/:id": <MaterialBalanceBreakdown />,
  "inventory-value-report-preview/:id/:historyId": (
    <InventoryValueReportPreview />
  ),
  "stock-availability": <StockAvailabilityReport />,
  "view-material-issue-details/:id": <MaterialDetails />,

  suppliers: <Suppliers />,
  addSuppliers: <AddSupplier />,

  "create-consumption-target": <BOQCreationMain />,

  "consumption-target-list": <BOQList />,

  "consumption_target_view/:targetId": <BoqViewDeatils />,

  "consumption-target-Report": <BoqReport />,

  "view-purchase-reports": <ViewAllReportsList />,
  "view-accounts-payable-reports": <ViewAllReportsList />,
  "purchase-order-report-preview/:orderNumber": <PurchaseOrderPreview />,
  "purchase-order-reports-list": <PurchaseOrderReports />,

  "purchase-by-supplier-reports-list": <PurchaseBySupplier />,
  "purchase-by-supplier-detail-report/:id": <PurchaseBySupplierDetailReport />,

  "purchase-by-material-reports-list": <PurchaseByMaterialReport />,
  "purchase-by-material-reports-detail-report/:id": (
    <PurchaseByMaterialDetailReport />
  ),

  "purchase-by-category-reports-list": <PurchaseByCategoryReport />,
  "order-details-by-category-report/:id": <OrderDetailsByCategoryReport />,
  // "invoice-details-by-category-report/:id": <InvoiceDetailsByCategoryReport />,

  "purchase-by-site-reports-list": <PurchaseBySiteReport />,
  "order-details-by-site-report/:id": <OrderDetailsBySiteReport />,
  // "invoice-details-by-site-report/:id": <InvoiceDetailsBySiteReport />,

  "invoice-by-supplier-reports-list": <InvoiceBySupplierReport />,
  "invoice-preview-report/:id": <InvoicePreviewReport />,

  "delivery-note-details": <DeliveryNoteDetailsReport />,
  "materials-by-delivery-note-report/:id": <MaterialsByDeliveryNoteReport />,

  "supplier-payments-reports-list": <SupplierPaymentsReport />,
  "supplier-payments-invoice-report/:id": <SupplierPaymentsInvoiceReport />,

  "payment-aging-summary-reports-list": <PaymentsAgingSummaryReport />,
  "payments-aging-summary-invoice-report/:id": (
    <PaymentsAgingSummaryInvoiceReport />
  ),

  "payment-aging-reports-list": <PaymentsAgingReport />,
  "payment-reports-list": <PaymentsReport />,
  "invoice-details-for-payments-report/:id": (
    <InvoiceDetailsForPaymentsReport />
  ),

  "supplier-balances-report": <SupplierBalancesReport />,
  "supplierBalancesDetailReport/:id": <SupplierBalancesDetailReport />,
  "supplier-ledger-reports-list": <SupplierLedgerReport />,
  "grn-preview-report/:id": <GRNPreview />,

  "view-budget-reports": <ViewAllReportsList />,
  "consumption_target_view/:targetId": <ViewBoqDetails />,
  "view-material-management-reports": <ViewAllReportsList />,
  "material-tracking-report-list": <BudgetTrackReport />,
  "material-consumption-report-list": <MaterialConsumptionReport />,
  "material-consumption-detail-report": <MaterialConsumptionDetailReport />,

  "material-request-summary-list": <MaterialRequestSummaryList />,
  "material-issue-summary-list": <MaterialIssueSummary />,
  "material-utilized-summary-list": <MaterialUtilizedSummary />,
  "material-damage-summary-list": <MaterialDamageSummary />,
  "material-summary-list": <MaterialSummary />,
  viewhistory: <VersionControlDefaultTemplate />,
  "material-summary-list-detail-report": <MaterialSummaryDetailReport />,
  // "auth-success": <Success />,
  // "auth-reset": <ResetPassword />,
  // "auth-register": <Register />,
  // setPassword: <SetPassword />,
  // success: <SuccessMain />,
  // errorEmail: <EmailError />,
  // "errors/404-modern": <Error404Modern />,
  // "errors/404-classic": <Error404Classic />,
  // "errors/504-modern": <Error504Modern />,
  // "errors/504-classic": <Error504Classic />,
  // "invoice-print/:invoiceId": <InvoicePrint />,
  "*": <Error404Modern />,
};
const menu = [
  {
    text: "Dashboard",
    link: "dashboard",
    // icon: <HomeOutlined />
  },
  {
    text: "Procure to Pay",
    subMenu: [
      {
        text: "BOQ",
        link: "consumption-target-list",
      },
      {
        text: "Budget",
        link: "analytics-budget",
        alt: ["view-budget"],
      },
      {
        text: "Rate Contracts",
        link: "view-rate-contract",
        alt: ["view-rate-contract"],
      },
      {
        text: "Purchase Request",
        link: "view-purchase-requests",
        alt: ["view-purchase-requests"],
      },
      {
        text: "Quotations",
        link: "analytics-rfq",
      },
      {
        text: "Purchase Orders",
        link: "view-purchase-order",
        alt: ["view-purchase-order"],
      },
      {
        text: "Invoices",
        link: "view-invoice-list",
        alt: ["view-invoice-list"],
      },
      {
        text: "Purchase Returns",
        link: "view-returns",
        alt: ["view-returns", "pending-approvals-returns"],
      },
      {
        text: "Credit Note",
        link: "all-credit-debit-notes",
        alt: ["all-credit-debit-notes"],
      },
      {
        text: "Payments",
        link: "payment-analytics",
        alt: ["view-payments"],
      },
    ],
  },
  {
    text: "Store Management",
    subMenu: [
      {
        text: "Goods Receipt Note",
        link: "view-dispatch-list",
        alt: ["view-dispatch-list"],
      },
      {
        text: "Material Issue",
        link: "site-inventory",
        alt: ["site-inventory"],
      },
      {
        text: "Material Handover",
        link: "material-handover-list",
        alt: ["material-handover-list"],
      },
      {
        text: "Material Utilization",
        link: "material-utilization",
        alt: ["material-utilization"],
      },
      {
        text: "Stock Availability",
        link: "stock-availability",
        alt: ["stock-availability"],
      },
      {
        text: "Analytics",
        link: "dashboard-inventory",
        alt: ["dashboard-inventory"],
      },
    ],
  },
  {
    text: "Reports",
    link: "view-purchase-reports",
    alt: [
      "view-purchase-reports",
      "view-accounts-payable-reports",
      "view-inventory-reports",
      "view-budget-reports",
      "view-material-management-reports",
    ],
  },
];
const Pages = ({ setIsLoggedIn }) => {
  const { data: currentUser } = useSelector((state) => state.currentUser);
  const [accessibility, setAccessibility] = useState([]);
  const [restrictedRoutes, setRestrictedRoutes] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    const currentPath = window.location.pathname;
    const isGlobalRoute = globalRoutes?.some((route) => {
      // Handle parameterized routes (e.g., /public-links/rfq/:linkId)
      if (route.includes(":")) {
        const routePattern = route.replace(/:[^/]+/g, "[^/]+");
        const regex = new RegExp(`^${routePattern}$`);
        return regex.test(currentPath);
      }
      return route === currentPath;
    });
    if (!currentUser && isAuthenticated && !isGlobalRoute) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch]);

  useEffect(() => {
    if (currentUser?.userRoutePermissions) {
      try {
        dispatch(fetchSequenceAccess());
        const { userRoutePermissions } = currentUser;
        const decodedString = atob(userRoutePermissions);
        const decodedData = JSON.parse(decodedString);
        console.log("decodedData", decodedData);
        dispatch(updateAccessibility(decodedData));
        const _allowedRoutes = [];
        const _restrictedRoutes = [];
        Object.keys(decodedData).forEach((mod) => {
          const module = decodedData[mod];
          if (module?.access) {
            module?.routes?.forEach((route) => {
              if (route?.permission) {
                _allowedRoutes.push(route?.path);
              } else {
                _restrictedRoutes.push(route?.path);
              }
            });
          }
        });

        setAccessibility(_allowedRoutes);
        setRestrictedRoutes(_restrictedRoutes);
        const _menu = [];
        menu?.forEach((item) => {
          if (item?.subMenu?.length > 0) {
            const subMenu = [];
            item?.subMenu?.forEach((subItem) => {
              if (subItem?.subMenu?.length > 0) {
                const _subMenuChildren = [];
                subItem?.subMenu?.forEach((subSubItem) => {
                  if (_allowedRoutes.includes(subSubItem?.link)) {
                    _subMenuChildren.push({
                      text: subSubItem?.text,
                      link: subSubItem?.link,
                      icon: subSubItem?.icon,
                    });
                  }
                });
                if (_subMenuChildren.length > 0) {
                  subMenu.push({
                    text: subItem?.text,
                    icon: subItem?.icon,
                    active: false,
                    subMenu: _subMenuChildren,
                  });
                }
                return;
              }
              if (_allowedRoutes.includes(subItem?.link)) {
                subMenu.push({
                  text: subItem?.text,
                  icon: subItem?.icon,
                  link: subItem?.link,
                });
              } else {
                if (subItem?.alt?.length > 0) {
                  const altLink = subItem?.alt?.find((link) =>
                    _allowedRoutes.includes(link)
                  );
                  if (altLink) {
                    subMenu.push({
                      text: subItem?.text,
                      icon: subItem?.icon,
                      link: altLink,
                    });
                  }
                }
              }
            });
            if (subMenu.length > 0) {
              _menu.push({
                text: item?.text,
                subMenu: subMenu,
                icon: item?.icon,
              });
            }
          } else {
            if (_allowedRoutes.includes(item?.link)) {
              _menu.push({
                text: item?.text,
                link: item?.link,
                icon: item?.icon,
              });
            } else if (item?.alt?.length > 0) {
              const altLink = item?.alt?.find((link) =>
                _allowedRoutes.includes(link)
              );
              if (altLink) {
                _menu.push({
                  text: item?.text,
                  icon: item?.icon,
                  link: altLink,
                });
              }
            }
          }
        });
        if (!_allowedRoutes?.includes("dashboard")) {
          _menu.unshift({
            text: "",
            link: "home",
            icon: <HomeOutlined style={{ fontSize: "18px" }} />,
          });
        }
        dispatch(updateMenuData(_menu));
        dispatch(updateAllowedRoutes(_allowedRoutes));
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    const currentPath = window.location.pathname;
    const isGlobalRoute = globalRoutes?.some((route) => {
      // Handle parameterized routes (e.g., /public-links/rfq/:linkId)
      if (route.includes(":")) {
        const routePattern = route.replace(/:[^/]+/g, "[^/]+");
        const regex = new RegExp(`^${routePattern}$`);
        return regex.test(currentPath);
      }
      return route === currentPath;
    });
    if (!isAuthenticated && !isGlobalRoute) {
      window.location.href = "/";
    }
  }, []);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
        <Route path="home" element={<DefaultDashboardPage />} />
        {accessibility?.map(
          (path) =>
            routesMap[path] && (
              <Route key={path} path={path} element={routesMap[path]} />
            )
        )}
        {restrictedRoutes?.map((path) => (
          <Route path={path} element={<div> Unauthorized Access</div>} />
        ))}
        <Route path="pr-summary-details" element={<PRSummaryDetailsPage />} />
        <Route path="notifications" element={<NotificationMain />} />
        {/* <Route path="viewhistory" element={<VersionControlDefaultTemplate />} /> */}
        <Route path="viewhistory" element={<VersionControl />} />
        <Route path="poHistory/:orderNumber" element={<POVersionControl />} />
        <Route path="prHistor" element={<PRVersionControl />} />
        <Route path="budget-analysis/:budgetId" element={<BudgetAnalysisReport />} />
        <Route path="privacy" element={<Faq />}></Route>
        <Route
          path="user-profile-regular"
          element={<UserProfileRegular />}
        ></Route>
        <Route
          path="user-profile-notification"
          element={<UserProfileNotification />}
        ></Route>
        <Route
          path="user-profile-activity"
          element={<UserProfileActivity />}
        ></Route>
        <Route
          path="excelexport-requested-list"
          element={<ExcelExportRequestedList />}
        ></Route>
        <Route path="bulk-upload-list" element={<BulkUploadList />}></Route>
        <Route
          path="user-profile-setting"
          element={<UserProfileSetting />}
        ></Route>
        <Route path="customer-admin" element={<CustomerAdminLayout />}>
          <Route path="subscription" element={<SubscriptionAccess />} />
          <Route path="invoices" element={<CustomerInvoices />} />
          <Route path="payments" element={<CustomerPayments />} />
        </Route>
      </Route>

      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-reset" element={<ResetPassword />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route index element={<Login setIsLoggedIn={setIsLoggedIn} />}></Route>
        <Route path="setPassword" element={<SetPassword />}></Route>
        <Route path="success" element={<SuccessMain />}></Route>
        <Route path="errorEmail" element={<EmailError />}></Route>
        <Route
          path="public-links/rfq/:linkId"
          element={<PublicQuotation />}
        ></Route>

        <Route
          path="*"
          element={
            accessibility.length === 0 ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <Error404Modern />
            )
          }
        ></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
